import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

function FAQ() {
  const { t } = useLanguage();
  const [activeFAQ, setActiveFAQ] = useState(null);

  const faqData = t.faq.items;

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const renderAnswer = (answer) => {
    if (typeof answer === 'string') {
      return <p dangerouslySetInnerHTML={{ __html: answer }}></p>;
    }
    
    return (
      <div style={{ marginBottom: '32px' }}>
        {answer.intro && <p dangerouslySetInnerHTML={{ __html: answer.intro }}></p>}
        {answer.list && (
          <ul style={{ marginBottom: '20px', listStyleType: 'disc', paddingLeft: '50px', color: 'var(--text-secondary)' }}>
            {answer.list.map((item, idx) => (
              <li key={idx} style={{ 
                marginBottom: '6px',
                lineHeight: '1.6'
              }}>
                <p style={{ 
                paddingBottom: '0', paddingLeft: '0'
              }} dangerouslySetInnerHTML={{ __html: item }}></p>
              </li>
            ))}
          </ul>
        )}
        {answer.conclusion && (
          <div>
            {answer.conclusion.map((para, idx) => (
              <p key={idx} style={{ marginBottom: '0px', paddingBottom: '0px' }} dangerouslySetInnerHTML={{ __html: para }}></p>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <section id="faq">
      <div className="container">
        <h2 className="section-title">{t.faq.title}</h2>
        <p className="section-subtitle">{t.faq.subtitle}</p>
        
        <div className="faq-container">
          {faqData.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className={`faq-question ${activeFAQ === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
              </button>
              <div className={`faq-answer ${activeFAQ === index ? 'active' : ''}`}>
                {renderAnswer(faq.answer)}
              </div>
            </div>
          ))}
        </div>
      </div>


    </section>
  );
}

export default FAQ;
